import styled from '@emotion/styled'

export const Cell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SelectOptionGuide = styled.div`
  padding: 8px 12px;
  color: #8c8ca1;
  display: flex;
  align-items: center;

  & > .text {
    margin-bottom: 0;
  }
`

export const SelectOptionExtra = styled.button`
  display: flex;
  cursor: pointer;
  padding: 8px 12px;
  background-color: transparent;
  width: 100%;
  border: 0;
  justify-content: space-between;
  color: #4a4a68;

  &:hover,
  &.-active {
    outline: 0;
    border: 0;
    background-color: #dbd9df;
  }

  & > .text {
    text-align: left;
    margin-right: auto;
    margin-bottom: 0;
  }

  & > .icon + .text {
    margin-left: 8px;
  }

  & > .help {
    font-size: 11px;
    opacity: 0.8;
    margin: 4px 0 4px 16px;
    flex: 0 0 auto;
    line-height: 1em;
  }
`
